import { render, staticRenderFns } from "./AsmensTurtai.vue?vue&type=template&id=0286981f&scoped=true&"
import script from "./AsmensTurtai.vue?vue&type=script&lang=js&"
export * from "./AsmensTurtai.vue?vue&type=script&lang=js&"
import style0 from "./AsmensTurtai.vue?vue&type=style&index=0&id=0286981f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286981f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
